<div *ngIf="committeeMeeting" ngModelGroup="meetingAgenda" class="atlas-form mct-flex mct-col mct-gap-27"  >
  <h4>{{ 'committees.edit.committee-meetings.attendance.title' | translate | titlecase }}</h4>
  <span class="light-text">{{ 'committees.edit.committee-meetings.attendance.help-text' | translate | ucfirst }}</span>
  <div>
    <button pButton type="button" class="atlas-btn atlas-btn-primary mct-flex mct-row mct-justify-center mct-items-center"   (click)="guestAddDialog.open()">
      <i class="pi pi-plus"></i>
      {{ 'committees.edit.committee-meetings.attendance.add-a-guest' | translate | uppercase }}
    </button>
  </div>
  <wl-committee-meeting-attendance-grid #attendanceGrid [meetingId]="committeeMeeting.MeetingID"></wl-committee-meeting-attendance-grid>

  <wl-committee-meeting-attendance-guest-add-dialog
    #guestAddDialog
    [meetingId]="committeeMeeting.MeetingID"
    [committeeId]="committeeMeeting.CommitteeID"
    (guestAdded)="attendanceGrid.search()"
  ></wl-committee-meeting-attendance-guest-add-dialog>
</div>
